angular.module('logbook')
    .factory('reportMapping', [function() {
        var service = {};

        service.createPayload = function(ruleObject, reportId, sortOrderCount, overridesOnly, defaultBasicNoteTemplateId) {
            var fieldMap = {
                    "template": "/api/noteFields/14",
                    "note": null,
                    "note-timeframe": "/api/noteFields/17",
                    "note-date-time": "/api/noteFields/2",
                    "carry-forward-end-time": "/api/noteFields/16",
                    "update-date-time": "/api/noteFields/4",
                    "note-creation-date-time": "/api/noteFields/2",
                    "tags": "/api/noteFields/10",
                    "note-contents": "/api/noteFields/7",
                    "created-by": "/api/noteFields/3",
                    "updated-by": "/api/noteFields/5",
                    "turnover": "/api/noteFields/8",
                    "carry-forward": "/api/noteFields/15",
                    "attachments": "/api/noteFields/13",
                    "comments": "/api/noteFields/12"
                },
                segmentTypeMap = {
                    "signoff": "/api/templateSegmentTypes/12"
                },
                operatorMap = {
                    "AND": "/api/logicalOperators/1",
                    "OR": "/api/logicalOperators/2"
                },
                payload = {
                    flags: {}
                };

            if (!overridesOnly) {
                payload.report = '/api/reports/' + reportId;
                payload.sortOrder = sortOrderCount;
                payload.allowConfigOnQuery = ruleObject.data.allowConfigureOnQuery;
            }

            if (fieldMap.hasOwnProperty(ruleObject.field)) {
                if (!overridesOnly) payload.noteField = fieldMap[ruleObject.field];

                switch (ruleObject.field) {
                    case 'template':
                        switch (ruleObject.operator) {
                            case 'basic-notes-template':
                                payload.flags.includeTemplateNotes = false;
                                break;
                            case 'inspection-only-template':
                                payload.flags.includeBasicNotes = false;
                                payload.templateTypes = ['/api/templateTypes/2'];
                                break;
                            case 'operational-only-template':
                                payload.flags.includeBasicNotes = false;
                                payload.templateTypes = ['/api/templateTypes/1'];
                                break;
                            case 'is-template':
                                var template = ruleObject.value.subTemplateId ?
                                    ruleObject.value.subTemplateId + 'S' :
                                    ruleObject.value.templateId + 'T';
                                
                                // The default for both of these flags is true
                                if (ruleObject.value.templateId == defaultBasicNoteTemplateId)
                                    payload.flags.includeTemplateNotes = false;
                                else
                                    payload.flags.includeBasicNotes = false;

                                payload.templates = ['/api/templates/' + template];
                                break;
                            case 'includes-any-of-template':
                            case 'excludes-all-of-template':
                                if (ruleObject.value[0].length) {
                                    var templates;
                                    if (ruleObject.value.includes('Basic NoteT')) {
                                        templates = ruleObject.value.filter(function(element) {
                                            return element !== 'Basic NoteT';
                                        });

                                        payload.flags.includeBasicNotes = ruleObject.operator === 'includes-any-of-template';

                                        if (!templates.length)
                                            payload.flags.includeTemplateNotes = ruleObject.operator === 'excludes-all-of-template';
                                    }
                                    else {
                                        templates = ruleObject.value;
                                        payload.flags.includeBasicNotes = ruleObject.operator === 'excludes-all-of-template';

                                        if (overridesOnly)
                                            payload.flags.includeTemplateNotes = null;
                                    }

                                    if (templates.length) {
                                        payload.templates = templates.map(function (element) {
                                            return '/api/templates/' + element;
                                        });

                                        if (ruleObject.operator === 'excludes-all-of-template')
                                            payload.flags.negateTemplates = true;
                                    }
                                    else if (overridesOnly) {
                                        payload.templates = null;
                                        payload.flags.negateTemplates = null;
                                    }
                                }
                                else if (overridesOnly) {
                                    payload.templates = null;
                                    payload.flags.negateTemplates = null;
                                    payload.flags.includeBasicNotes = null;
                                    payload.flags.includeTemplateNotes = null;
                                }
                                break;
                        }
                        break;

                    case 'note':
                        switch (ruleObject.operator) {
                            case 'has-abnormal-choices-note':
                            case 'not-has-abnormal-choices-note':
                                payload.flags.abnormalChoices = ruleObject.value;
                                break;
                            case 'has-out-of-range-note':
                            case 'not-has-out-of-range-note':
                                payload.flags.outOfRange = ruleObject.value;
                                break;
                            case 'has-pending-signoffs-note':
                            case 'not-has-pending-signoffs-note':
                                payload.flags.pendingSignoffs = ruleObject.value;
                                break;
                            case 'has-pending-signoffs-users-note':
                                payload.flags.pendingSignoffs = true;
                                if (ruleObject.value[0].length) {
                                    payload.users = ruleObject.value.map(function (element) {
                                        if (element === 'current') {
                                            payload.flags.includeCurrentUser = true;
                                            return element;
                                        }
                                        else return '/api/logBookUsers/' + element;
                                    });
                                    if (payload.users.includes('current')) payload.users.splice(payload.users.indexOf('current'), 1);
                                } else if (overridesOnly) {
                                    payload.users = null;
                                    payload.flags.includeCurrentUser = null;
                                }
                                break;
                            case 'has-rejected-signoffs-note':
                            case 'not-has-rejected-signoffs-note':
                                payload.templateSegmentType = segmentTypeMap['signoff'];
                                payload.booleanValue = false;
                                payload.flags.negate = ruleObject.operator === 'not-has-rejected-signoffs-note' ? true : null;
                                break;
                        }
                        break;

                    case 'note-timeframe':
                    case 'note-date-time':
                    case 'update-date-time':
                    case 'note-creation-date-time':
                        createDateTimePayload(ruleObject, payload, overridesOnly);
                        break;

                    case 'tags':
                        switch (ruleObject.operator) {
                            case 'any-tags':
                                payload.numericFrom = '1';
                                break;
                            case 'none-tags':
                                payload.numericThru = '0';
                                break;
                            case 'includes-all-of-tags':
                            case 'includes-any-of-tags':
                            case 'missing-all-of-tags':
                            case 'missing-any-of-tags':
                                if (ruleObject.value[0].length) {
                                    payload.tagValues = ruleObject.value.map(function (element) {
                                        return '/api/tagValues/' + element;
                                    });
                                    payload.tagOperator = ruleObject.operator === 'includes-all-of-tags' || ruleObject.operator === 'missing-any-of-tags' ?
                                        operatorMap['AND'] : operatorMap['OR'];
                                    if (ruleObject.operator === 'missing-all-of-tags' || ruleObject.operator === 'missing-any-of-tags')
                                        payload.flags.negateTags = true;
                                } else if (overridesOnly) {
                                    payload.tagValues = null;
                                    payload.tagOperator = null;
                                    payload.flags.negateTags = null;
                                }
                                break;
                        }
                        break;

                    case 'note-contents':
                        if (ruleObject.value[0].length) {
                            payload.contains = [ruleObject.value[0]];
                            payload.flags.caseSensitive = ruleObject.value[1]['case-sensitive'];
                            payload.flags.wholeWord = ruleObject.value[1]['whole-word'];
                            payload.flags.allowWildcards = ruleObject.value[1]['wildcards'];
                            if (ruleObject.operator === 'not-contains-note-contents') payload.flags.negateContains = true;
                        } else if (overridesOnly) {
                            payload.contains = null;
                            payload.flags.caseSensitive = null;
                            payload.flags.wholeWord = null;
                            payload.flags.allowWildcards = null;
                            payload.flags.negateContains = null;
                        }
                        break;

                    case 'created-by':
                    case 'updated-by':
                        if (ruleObject.value[0].length) {
                            payload.users = ruleObject.value.map(function (element) {
                                if (element === 'current') {
                                    payload.flags.includeCurrentUser = true;
                                    return element;
                                }
                                else return '/api/logBookUsers/' + element;
                            });
                            if (payload.users.includes('current')) payload.users.splice(payload.users.indexOf('current'), 1);
                            if (ruleObject.operator === 'excludes-all-of-users') payload.flags.negateUsers = true;
                        } else if (overridesOnly) {
                            payload.users = null;
                            payload.flags.includeCurrentUser = null;
                            payload.flags.negateUsers = null;
                        }
                        break;

                    case 'turnover':
                        if (ruleObject.value) payload.booleanValue = ruleObject.value;
                        else if (overridesOnly) payload.booleanValue = null;
                        break;

                    case 'carry-forward':
                        switch (ruleObject.operator) {
                            case 'is-carry-forward':
                            case 'not-carry-forward': 
                            case 'all-carry-forward':
                                payload.booleanValue = ruleObject.value;
                                break;
                            case 'active-carry-forward':
                                payload.flags.activeCarryForward = true;
                                break;
                            case 'ended-carry-forward':
                                payload.flags.endedCarryForward = true;
                                break;
                            case 'start-date-carry-forward':
                            case 'start-date-range-carry-forward':
                            case 'start-time-range-carry-forward':
                                if (!overridesOnly) payload.noteField = fieldMap["note-date-time"];
                                createDateTimePayload(ruleObject, payload, overridesOnly);
                                break;
                            case 'end-date-carry-forward':
                            case 'end-date-range-carry-forward':
                            case 'end-time-range-carry-forward':
                                if (!overridesOnly) payload.noteField = fieldMap["carry-forward-end-time"];
                                createDateTimePayload(ruleObject, payload, overridesOnly);
                                break;
                        }
                        break;

                    case 'attachments':
                        switch (ruleObject.operator) {
                            case 'any-attachments':
                            case 'none-attachments':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'filename-attachments':
                                if (ruleObject.value.length) payload.contains = [ruleObject.value];
                                else if (overridesOnly) payload.contains = null;
                                break;
                            case 'extension-attachments':
                                if (ruleObject.value.length) payload.extension = ruleObject.value;
                                else if (overridesOnly) payload.extension = null;
                                break;
                            case 'number-attachments':
                                createNumericPayload(ruleObject, payload, overridesOnly);
                                break;
                        }
                        break;

                    case 'comments':
                        switch (ruleObject.operator) {
                            case 'any-comments':
                            case 'none-comments':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'contains-comments':
                            case 'not-contains-comments':
                                if (ruleObject.value.length) {
                                    payload.contains = [ruleObject.value];
                                    if (ruleObject.operator === 'not-contains-comments') payload.flags.negateContains = true;
                                } else if (overridesOnly) {
                                    payload.contains = null;
                                    payload.flags.negateContains = null;
                                }
                                break;
                            case 'made-by-comments':
                            case 'not-made-by-comments':
                                if (ruleObject.value[0].length) {
                                    payload.users = ruleObject.value.map(function (element) {
                                        if (element === 'current') {
                                            payload.flags.includeCurrentUser = true;
                                            return element;
                                        }
                                        else return '/api/logBookUsers/' + element;
                                    });
                                    if (payload.users.includes('current')) payload.users.splice(payload.users.indexOf('current'), 1);
                                    if (ruleObject.operator === 'not-made-by-comments') payload.flags.negateUsers = true;
                                } else if (overridesOnly) {
                                    payload.users = null;
                                    payload.flags.includeCurrentUser = null;
                                    payload.flags.negateUsers = null;
                                }
                                break;
                            case 'time-added-comments':
                                if (ruleObject.value[0].length || ruleObject.value[1].length) {
                                    payload.dtFrom = ruleObject.value[0] ? new Date(ruleObject.value[0]).toISOString() : null;
                                    payload.dtThru = ruleObject.value[1] ? new Date(ruleObject.value[1]).toISOString() : null;
                                } else if (overridesOnly) {
                                    payload.dtFrom = null;
                                    payload.dtThru = null;
                                }
                                break;
                        }
                        break;
                }
            } else {
                if (!overridesOnly) payload.templateSegment = "/api/templateSegments/" + ruleObject.field;

                var createInspectionSegmentsPayload = function () {
                    switch (ruleObject.operator) {
                        case 'has-segment-comment':
                        case 'has-no-segment-comment':
                            payload.flags.hasComment = ruleObject.value;
                            break;
                        case 'has-segment-attachment':
                        case 'has-no-segment-attachment':
                            payload.flags.hasAttachment = ruleObject.value;
                            break;
                    }
                };

                switch (ruleObject.data.logBookTemplateSegmentType) {
                    case 'Text Input':
                        switch (ruleObject.operator) {
                            case 'any-text-input':
                            case 'none-text-input':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'contains-text-input':
                            case 'not-contains-text-input':
                                if (ruleObject.value[0].length) {
                                    payload.contains = [ruleObject.value[0]];
                                    payload.flags.caseSensitive = ruleObject.value[1]["case-sensitive"];
                                    payload.flags.wholeWord = ruleObject.value[1]["whole-word"];
                                    payload.flags.allowWildcards = ruleObject.value[1]["wildcards"];
                                    if (ruleObject.operator === 'not-contains-text-input') payload.flags.negateContains = true;
                                } else if (overridesOnly) {
                                    payload.contains = null;
                                    payload.flags.caseSensitive = null;
                                    payload.flags.wholeWord = null;
                                    payload.flags.allowWildcards = null;
                                    payload.flags.negateContains = null;
                                }
                                break;
                            default:
                                createInspectionSegmentsPayload();
                        }
                        break;

                    case 'Numeric Input':
                        switch (ruleObject.operator) {
                            case 'any-numeric':
                            case 'none-numeric':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'is-numeric':
                                createNumericPayload(ruleObject, payload, overridesOnly);
                                break;
                            case 'out-of-range':
                            case 'not-out-of-range':
                                payload.flags.outOfRange = ruleObject.value;
                                break;
                            default:
                                createInspectionSegmentsPayload();
                        }
                        break;

                    case 'Checkbox':
                        var valueMap = {
                            'Checked': 'checked',
                            'Un-checked': 'unchecked',
                            'Neither checked nor un-checked': 'null'
                        };
                        if (ruleObject.operator === 'is-checkbox')
                            payload.contains = [valueMap[ruleObject.value]];
                        else
                            createInspectionSegmentsPayload();
                        break;

                    case 'Date/Time':
                        switch (ruleObject.operator) {
                            case 'specific-date':
                            case 'date-range':
                            case 'time-range':
                                createDateTimePayload(ruleObject, payload, overridesOnly);
                                break;
                            default:
                                createInspectionSegmentsPayload();
                                break;
                        }
                        break;

                    case 'Text Choice':
                        switch (ruleObject.operator) {
                            case 'any-text-choice':
                            case 'none-text-choice':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'includes-any-of-text-choice':
                            case 'missing-all-of-text-choice':
                                if (ruleObject.value[0].length) {
                                    payload.contains = ruleObject.value;
                                    if (ruleObject.operator === 'missing-all-of-text-choice') payload.flags.negateContains = true;
                                } else if (overridesOnly) {
                                    payload.contains = null;
                                    payload.flags.negateContains = null;
                                }
                                break;
                            case 'abnormal-choice':
                            case 'not-abnormal-choice':
                                payload.flags.abnormalChoices = ruleObject.value;
                                break;
                            default:
                                createInspectionSegmentsPayload();
                                break;
                        }
                        break;

                    case 'Tag Choice':
                        switch (ruleObject.operator) {
                            case 'any-tags':
                            case 'none-tags':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'includes-all-of-tags':
                            case 'includes-any-of-tags':
                            case 'missing-all-of-tags':
                            case 'missing-any-of-tags':
                                if (ruleObject.value[0].length) {
                                    payload.tagValues = ruleObject.value.map(function (element) {
                                        return '/api/tagValues/' + element;
                                    });
                                    payload.tagOperator = ruleObject.operator === 'includes-all-of-tags' || ruleObject.operator === 'missing-any-of-tags' ?
                                        operatorMap['AND'] : operatorMap['OR'];
                                    if (ruleObject.operator === 'missing-all-of-tags' || ruleObject.operator === 'missing-any-of-tags')
                                        payload.flags.negateTags = true;
                                } else if (overridesOnly) {
                                    payload.tagValues = null;
                                    payload.tagOperator = null;
                                    payload.flags.negateTags = null;
                                }
                                break;
                            default:
                                createInspectionSegmentsPayload();
                                break;
                        }
                        break;

                    case 'Signoff':
                        switch (ruleObject.operator) {
                            case 'any-signoff':
                            case 'none-signoff':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'pending-includes-any-of-signoff':
                            case 'includes-any-of-signoff':
                            case 'excludes-all-of-signoff':
                                if (ruleObject.value[0].length) {
                                    payload.users = ruleObject.value.map(function (element) {
                                        if (element === 'current') {
                                            payload.flags.includeCurrentUser = true;
                                            return element;
                                        }
                                        else return '/api/logBookUsers/' + element;
                                    });
                                    if (payload.users.includes('current')) payload.users.splice(payload.users.indexOf('current'), 1);
                                    if (ruleObject.operator === 'excludes-all-of-signoff') payload.flags.negateUsers = true;
                                    if (ruleObject.operator === 'pending-includes-any-of-signoff') payload.flags.pendingSignoffs = true;
                                } else if (overridesOnly) {
                                    payload.users = null;
                                    payload.flags.includeCurrentUser = null;
                                    payload.flags.negateUsers = null;
                                    payload.flags.pendingSignoffs = null;
                                }
                                break;
                            case 'specific-date-signoff':
                            case 'date-range-signoff':
                            case 'time-range-signoff':
                                createDateTimePayload(ruleObject, payload, overridesOnly);
                                break;
                            case 'rejected-signoff':
                            case 'not-rejected-signoff':
                                payload.booleanValue = false;
                                payload.flags.negate = ruleObject.operator === 'not-rejected-signoff' ? true : null;
                                break;
                        }
                        break;

                    case 'File Attachment':
                        switch (ruleObject.operator) {
                            case 'any-attachments':
                            case 'none-attachments':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'filename-attachments':
                                if (ruleObject.value.length) payload.contains = [ruleObject.value];
                                else if (overridesOnly) payload.contains = null;
                                break;
                            case 'extension-attachments':
                                if (ruleObject.value.length) payload.extension = ruleObject.value;
                                else if (overridesOnly) payload.extension = null;
                                break;
                            case 'number-attachments':
                                createNumericPayload(ruleObject, payload, overridesOnly);
                                break;
                            default:
                                createInspectionSegmentsPayload();
                                break;
                        }
                        break;

                    case 'User Chooser':
                        switch (ruleObject.operator) {
                            case 'any-users':
                            case 'none-users':
                                payload.flags.hasValue = ruleObject.value;
                                break;
                            case 'includes-any-of-users':
                            case 'excludes-all-of-users':
                                if (ruleObject.value[0].length) {
                                    payload.users = ruleObject.value.map(function (element) {
                                        if (element === 'current') {
                                            payload.flags.includeCurrentUser = true;
                                            return element;
                                        }
                                        else return '/api/logBookUsers/' + element;
                                    });
                                    if (payload.users.includes('current')) payload.users.splice(payload.users.indexOf('current'), 1);
                                    if (ruleObject.operator === 'excludes-all-of-users') payload.flags.negateUsers = true;
                                } else if (overridesOnly) {
                                    payload.users = null;
                                    payload.flags.includeCurrentUser = null;
                                    payload.flags.negateUsers = null;
                                }
                                break;
                            default:
                                createInspectionSegmentsPayload();
                                break;
                        }
                        break;
                }
            }

            if (Object.keys(payload.flags).length === 0)
                delete payload.flags;

            return payload;
        };

        function createDateTimePayload(ruleObject, payload, overridesOnly) {
            var timeMap = {
                    "day": "/api/timeUnits/3",
                    "week": "/api/timeUnits/4",
                    "month": "/api/timeUnits/5",
                    "quarter": "/api/timeUnits/6",
                    "year": "/api/timeUnits/7",
                    "weekday": "/api/timeUnits/8"
                },
                weekdayMap = {
                    "Saturday": "0",
                    "Sunday": "1",
                    "Monday": "2",
                    "Tuesday": "3",
                    "Wednesday": "4",
                    "Thursday": "5",
                    "Friday": "6"
                };

            if (ruleObject.data.htmlTemplateId === 'lb-dt-time-only-template-segment') {
                if (ruleObject.value[0].length) payload.timeFrom = ruleObject.value[0] + ':00';
                else if (overridesOnly) payload.timeFrom = null;
                if (ruleObject.value[1].length) {
                    var end = new Date('01/01/1970 ' + ruleObject.value[1] + ':00');
                    end.setMinutes(end.getMinutes() + 1);
                    payload.timeThru = end.getHours() + ':' + (end.getMinutes() < 10 ? '0' + end.getMinutes() : end.getMinutes()) + ':00';
                    payload.flags.timeThruStrictlyLT = true;
                } else if (overridesOnly) {
                    payload.timeThru = null;
                    payload.flags.timeThruStrictlyLT = null;
                }
            } else {
                switch (ruleObject.value[0]) {
                    case "Today":
                        payload.timeUnit = timeMap["day"];
                        payload.numericFrom = "0";
                        break;
                    case "Yesterday":
                        payload.timeUnit = timeMap["day"];
                        payload.numericFrom = "-1";
                        payload.numericThru = "0";
                        break;
                    case "Number of Days Ago":
                        if (!isNaN(ruleObject.value[1])) {
                            payload.timeUnit = timeMap["day"];
                            payload.numericFrom = (-ruleObject.value[1]).toString();
                            payload.numericThru = (1 - ruleObject.value[1]).toString();
                        }
                        break;
                    case "Previous Weekday":
                        payload.timeUnit = timeMap["weekday"];
                        payload.numericFrom = weekdayMap[ruleObject.value[1]];
                        payload.numericThru = payload.numericFrom === "6" ? "0" : (parseInt(payload.numericFrom) + 1).toString();
                        break;
                    case "Specific Date":
                        if (ruleObject.value[1].length) {
                            var start = new Date(ruleObject.value[1] + " 00:00:00"),
                                end = new Date(ruleObject.value[1] + " 00:00:00");
                            end.setDate(end.getDate() + 1);
                            payload.dtFrom = start.toISOString();
                            payload.dtThru = end.toISOString();
                            payload.flags.dtThruStrictlyLT = true;
                        } else if (overridesOnly) {
                            payload.dtFrom = null;
                            payload.dtThru = null;
                            payload.flags.dtThruStrictlyLT = null;
                        }
                        if (overridesOnly) {
                            payload.timeUnit = null;
                            payload.numericFrom = null;
                            payload.numericThru = null;
                        }
                        break;
                    case "This Week":
                        payload.timeUnit = timeMap["week"];
                        payload.numericFrom = "0";
                        break;
                    case "Last Week":
                        payload.timeUnit = timeMap["week"];
                        payload.numericFrom = "-1";
                        payload.numericThru = "0";
                        break;
                    case "This Month":
                        payload.timeUnit = timeMap["month"];
                        payload.numericFrom = "0";
                        break;
                    case "Last Month":
                        payload.timeUnit = timeMap["month"];
                        payload.numericFrom = "-1";
                        payload.numericThru = "0";
                        break;
                    case "This Quarter":
                        payload.timeUnit = timeMap["quarter"];
                        payload.numericFrom = "0";
                        break;
                    case "Last Quarter":
                        payload.timeUnit = timeMap["quarter"];
                        payload.numericFrom = "-1";
                        payload.numericThru = "0";
                        break;
                    case "This Year":
                        payload.timeUnit = timeMap["year"];
                        payload.numericFrom = "0";
                        break;
                    case "Last Year":
                        payload.timeUnit = timeMap["year"];
                        payload.numericFrom = "-1";
                        payload.numericThru = "0";
                        break;
                    case "Between Days Ago":
                        if (!isNaN(ruleObject.value[1]) || !isNaN(ruleObject.value[2])) {
                            payload.timeUnit = timeMap["day"];
                            if (!isNaN(ruleObject.value[1])) payload.numericFrom = (-ruleObject.value[1]).toString();
                            if (!isNaN(ruleObject.value[2])) payload.numericThru = (-ruleObject.value[2]).toString();
                        }
                        break;
                    case "Between Dates":
                        if (ruleObject.value[1] || ruleObject.value[2]) {
                            var start = ruleObject.value[1] ? new Date(ruleObject.value[1] + " 00:00:00") : null,
                                end = ruleObject.value[2] ? new Date(ruleObject.value[2] + " 00:00:00") : null;
                            if (start) payload.dtFrom = start.toISOString();
                            if (end) {
                                end.setDate(end.getDate() + 1);
                                payload.dtThru = end.toISOString();
                                payload.flags.dtThruStrictlyLT = true;
                            }
                        } else if (overridesOnly) {
                            payload.dtFrom = null;
                            payload.dtThru = null;
                            payload.flags.dtThruStrictlyLT = null;
                        }
                        if (overridesOnly) {
                            payload.timeUnit = null;
                            payload.numericFrom = null;
                            payload.numericThru = null;
                        }
                        break;
                    case "Between Dates/Times":
                        if (ruleObject.value[1] || ruleObject.value[2]) {
                            var start = ruleObject.value[1] ? new Date(ruleObject.value[1]) : null,
                                end = ruleObject.value[2] ? new Date(ruleObject.value[2]) : null;
                            if (start) payload.dtFrom = start.toISOString();
                            if (end) {
                                end.setMinutes(end.getMinutes() + 1);
                                payload.dtThru = end.toISOString();
                                payload.flags.dtThruStrictlyLT = true;
                            }
                        } else if (overridesOnly) {
                            payload.dtFrom = null;
                            payload.dtThru = null;
                            payload.flags.dtThruStrictlyLT = null;
                        }
                        if (overridesOnly) {
                            payload.timeUnit = null;
                            payload.numericFrom = null;
                            payload.numericThru = null;
                        }
                        break;
                }
                if (ruleObject.operator === 'time-range' && !overridesOnly) payload.flags.includeTime = true;
            }
        }

        function createNumericPayload(ruleObject, payload, overridesOnly) {
            if (ruleObject.value[1]) {
                switch (ruleObject.value[0]) {
                    case '>':
                    case '>=':
                        payload.numericFrom = ruleObject.value[1];
                        if (ruleObject.value[0] === '>') payload.flags.numericFromStrictlyGT = true;
                        else if (overridesOnly) payload.flags.numericFromStrictlyGT = null;
                        if (overridesOnly) {
                            payload.numericThru = null;
                            payload.flags.numericThruStrictlyLT = null;
                        }
                        break;
                    case '<':
                    case '<=':
                        payload.numericThru = ruleObject.value[1];
                        if (ruleObject.value[0] === '<') payload.flags.numericThruStrictlyLT = true;
                        else if (overridesOnly) payload.flags.numericThruStrictlyLT = null;
                        if (overridesOnly) {
                            payload.numericFrom = null;
                            payload.flags.numericFromStrictlyGT = null;
                        }
                        break;
                    case '=':
                        payload.numericFrom = ruleObject.value[1];
                        payload.numericThru = ruleObject.value[1];
                        if (overridesOnly) {
                            payload.flags.numericFromStrictlyGT = null;
                            payload.flags.numericThruStrictlyLT = null;
                        }
                        break;
                }
            } else if (overridesOnly) {
                payload.numericFrom = null;
                payload.numericThru = null;
                payload.flags.numericFromStrictlyGT = null;
                payload.flags.numericThruStrictlyLT = null;
            }
        }

        return service;
    }]);